import React from 'react';

// Components
import Icon from '.';

// Interfaces
import { Icon as IconInterface } from '../../interfaces/icon';

interface IconsProps {
  icons: Array<IconInterface>;
  columnSpan: number;
  extraClasses: string;
}

function Icons({ icons, columnSpan, extraClasses }: IconsProps) {
  return (
    <div className={`cl-row ${extraClasses ? extraClasses : ''}`}>
      {icons &&
        icons.map((icon, index: number) => {
          return (
            <Icon
              body={icon.body}
              link={icon.link}
              columnSpan={columnSpan}
              extraClasses={icon.extraClasses}
              key={index}
            />
          );
        })}
    </div>
  );
}

export default Icons;
